/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Tooltip from '../common/Tooltip';

const propTypes = {
    settingsData: PropTypes.object.isRequired,
    onSettingChange: PropTypes.func.isRequired,
    servicesStructure: PropTypes.object.isRequired,
};

class SalesSettings extends Component {
    render() {
        const { settingsData, onSettingChange, servicesStructure } = this.props;
        const badFeedbackOptions = [];
        for (let i = 1; i <= 5; i += 1) {
            badFeedbackOptions.push({ value: i, label: i.toString() });
        }
        const maxNumOfServicesOptions =
            Object.keys(servicesStructure)
                .filter(key => key)
                .map((_, i) => ({
                    value: i + 1,
                    label: i + 1
                }))

        const recurrenceDaysOptions = [];
        for (let i = 1; i <= 30; i += 1) {
            recurrenceDaysOptions.push({ value: i, label: i.toString() });
        }

        const minMatchingScore = parseFloat(
            settingsData.MINIMUM_MATCHING_SCORE_THRESHOLD.toFixed(2),
        );
        const maxMatchingScore = parseFloat(
            settingsData.MAXIMUM_MATCHING_SCORE_THRESHOLD.toFixed(2),
        );

        const minMatchingScoreOptions = [];
        const maxMatchingScoreOptions = [];
        for (let i = 0; i <= maxMatchingScore * 10; i += 0.5) {
            minMatchingScoreOptions.push({
                value: (i / 10).toFixed(2),
                label: i.toFixed(1).toString(),
            });
        }
        for (let i = minMatchingScore * 10; i <= 10; i += 0.5) {
            maxMatchingScoreOptions.push({
                value: (i / 10).toFixed(2),
                label: i.toFixed(1).toString(),
            });
        }

        return (
            <div className="system-settings-section">
                <div className="system-settings-section__header">
                    <div className="system-settings-section__title">
                        Sales & Customers
                    </div>
                </div>
                <div className="system-settings-section__content">
                    <div className="system-settings-section__subtitle">
                        Customer communication
                    </div>
                    <table className="table-settings">
                        <tbody>
                            <tr>
                                <td>
                                    <span>NPS Campaigns enabled</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Enable Net Promoter Score emails to be sent out to clients periodically">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <label className="settings-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={settingsData.NPS_CAMPAIGNS}
                                            onChange={event => {
                                                onSettingChange({
                                                    NPS_CAMPAIGNS:
                                                        event.target.checked,
                                                });
                                            }}
                                        />
                                        <div className="settings-checkbox__container">
                                            <div className="settings-checkbox__indicator" />
                                            <span className="settings-checkbox__yes-label">
                                                Yes
                                            </span>
                                            <span className="settings-checkbox__no-label">
                                                No
                                            </span>
                                        </div>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Client feedback enabled</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Enable feedback from clients.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <label className="settings-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={settingsData.CLIENT_FEEDBACK_ENABLED}
                                            onChange={event => {
                                                onSettingChange({
                                                    CLIENT_FEEDBACK_ENABLED:
                                                        event.target.checked,
                                                });
                                            }}
                                        />
                                        <div className="settings-checkbox__container">
                                            <div className="settings-checkbox__indicator" />
                                            <span className="settings-checkbox__yes-label">
                                                Yes
                                            </span>
                                            <span className="settings-checkbox__no-label">
                                                No
                                            </span>
                                        </div>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Bad feedback threshold</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Threshold score below which sorry email are sent to clients">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>

                                <td>
                                    <Select
                                        value={
                                            settingsData.BAD_CLIENT_FEEDBACK_THRESHOLD
                                        }
                                        clearable={false}
                                        onChange={option => {
                                            onSettingChange({
                                                BAD_CLIENT_FEEDBACK_THRESHOLD:
                                                    option.value,
                                            });
                                        }}
                                        options={badFeedbackOptions}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="system-settings-section__subtitle margin-top-10">
                        Jobs opening rules
                    </div>

                    <table className="table-settings">
                        <tbody>
                            <tr>
                                <td>
                                    <span>Maximum number of services per multi-sector job request</span>
                                </td>
                                <td>
                                    <Select
                                        value={settingsData.MAX_SERVICES_PER_MULTISERVICE_JOB}
                                        clearable={false}
                                        onChange={option => {
                                            onSettingChange({
                                                MAX_SERVICES_PER_MULTISERVICE_JOB: option.value,
                                            });
                                        }}
                                        options={maxNumOfServicesOptions}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Minimum job notice time</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Minimum notice time required to post jobs on the platform">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.MIN_JOB_NOTICE
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                MIN_JOB_NOTICE:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Minimum job duration</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="The minimum job duration clients can post">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.MIN_JOB_DURATION
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                MIN_JOB_DURATION:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Checkout job expiration</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="How long a job can stay in checkout before they are removed from the platform">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.CHECKOUT_EXPIRATION
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                CHECKOUT_EXPIRATION:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Open recurrence subscriptions days ahead
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="How many days before subscriptions are opened in the platform">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <Select
                                        value={
                                            settingsData.RECURRENCE_DAYS_AHEAD
                                        }
                                        clearable={false}
                                        onChange={option => {
                                            onSettingChange({
                                                RECURRENCE_DAYS_AHEAD:
                                                    option.value,
                                            });
                                        }}
                                        options={recurrenceDaysOptions}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Delayed series invitation sending</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="The time interval by which sending invitations is postponed after creating a series.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.DELAY_CREATE_INVITATIONS_WHEN_SERIES
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                DELAY_CREATE_INVITATIONS_WHEN_SERIES:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Delayed multiservice invitation sending</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="The time interval by which sending invitations is postponed after creating a multiservice job request.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="duration"
                                        defaultValue={
                                            settingsData.DELAY_CREATE_INVITATIONS_WHEN_MULTISERVICE
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                DELAY_CREATE_INVITATIONS_WHEN_MULTISERVICE:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Bookings e-mail</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Email address from which freelancers will receive bookings confirmation emails.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="settings-textfield"
                                        defaultValue={
                                            settingsData.BOOKINGS_EMAIL
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                BOOKINGS_EMAIL:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="system-settings-section__subtitle margin-top-10">
                        Default Assignment Details
                    </div>

                    <table className="table-settings">
                        <tbody>
                            <tr>
                                <td>
                                    <span>Health and safety risks</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip
                                            tooltip="Default description of workplace-specific health and safety risks and how the risk is prevented or controlled."
                                        >
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="settings-long-textfield"
                                        defaultValue={
                                            settingsData.DEFAULT_ASSIGNMENT_DETAILS.safety_risks
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                DEFAULT_ASSIGNMENT_DETAILS: {
                                                    ...settingsData.DEFAULT_ASSIGNMENT_DETAILS,
                                                    safety_risks: event.target.value
                                                }
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Any expenses payable by, or to the worker</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip
                                            tooltip="Default information about payable expenses."
                                        >
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="settings-long-textfield"
                                        defaultValue={
                                            settingsData.DEFAULT_ASSIGNMENT_DETAILS.expenses_payable
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                DEFAULT_ASSIGNMENT_DETAILS: {
                                                    ...settingsData.DEFAULT_ASSIGNMENT_DETAILS,
                                                    expenses_payable: event.target.value
                                                }
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Nature of the Hirer’s business</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip
                                            tooltip="Default sector, role, or business description."
                                        >
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="settings-long-textfield"
                                        defaultValue={
                                            settingsData.DEFAULT_ASSIGNMENT_DETAILS.nature_of_business
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                DEFAULT_ASSIGNMENT_DETAILS: {
                                                    ...settingsData.DEFAULT_ASSIGNMENT_DETAILS,
                                                    nature_of_business: event.target.value
                                                }
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Collective facilities</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip
                                            tooltip="Default description of the site specific facilities."
                                        >
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="settings-long-textfield"
                                        defaultValue={
                                            settingsData.DEFAULT_ASSIGNMENT_DETAILS.available_facilities
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                DEFAULT_ASSIGNMENT_DETAILS: {
                                                    ...settingsData.DEFAULT_ASSIGNMENT_DETAILS,
                                                    available_facilities: event.target.value
                                                }
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Experience and Training Required</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip
                                            tooltip="Default information about required qualifications."
                                        >
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="settings-long-textfield"
                                        defaultValue={
                                            settingsData.DEFAULT_ASSIGNMENT_DETAILS.required_qualifications
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                DEFAULT_ASSIGNMENT_DETAILS: {
                                                    ...settingsData.DEFAULT_ASSIGNMENT_DETAILS,
                                                    required_qualifications: event.target.value
                                                }
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="system-settings-section__subtitle margin-top-10">
                        Matching threshold
                    </div>

                    <table className="table-settings">
                        <tbody>
                            <tr>
                                <td>
                                    <span>
                                        Minimum applicant matching score
                                    </span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Minimum matching score required for workers to be invited">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <Select
                                        value={settingsData.MINIMUM_MATCHING_SCORE_THRESHOLD.toFixed(
                                            2,
                                        )}
                                        clearable={false}
                                        onChange={option => {
                                            onSettingChange({
                                                MINIMUM_MATCHING_SCORE_THRESHOLD:
                                                    option.value,
                                            });
                                        }}
                                        options={minMatchingScoreOptions}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>
                                        Maximum applicant matching score
                                    </span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Matching score after which workers application are accepted straight away (insta-book)">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <Select
                                        value={settingsData.MAXIMUM_MATCHING_SCORE_THRESHOLD.toFixed(
                                            2,
                                        )}
                                        clearable={false}
                                        onChange={option => {
                                            onSettingChange({
                                                MAXIMUM_MATCHING_SCORE_THRESHOLD:
                                                    option.value,
                                            });
                                        }}
                                        options={maxMatchingScoreOptions}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

SalesSettings.propTypes = propTypes;

export default SalesSettings;
